import { defineComponent } from 'vue';
import HelpAndSupportBlockCode from '@/presentation/components/help-and-support-block/help-and-support-block.code';

export default defineComponent({
	setup: () => {
		const code = new HelpAndSupportBlockCode();

		return {
			navigateToHelpCentrePage: code.navigateToHelpCentrePage.bind(code),
			navigateToContactSupportPage: code.navigateToContactSupportPage.bind(code)
		};
	}
});
